import { formatAmount } from '../../../../utils';
import { timestampPlusDays, toDate } from '../../../../utils/dateUtils';
import { MOMENTJS_DATE_FORMAT_STANDARD } from '../../../../constants/moment';

const getState = state => state.account.paymentrequest.ongoing;

export const getOnGoingPaymentRequest = state => getState(state).ongoing;

export const isCurrentOnGoingPayementRequest = state =>
    getOnGoingPaymentRequest(state) && getOnGoingPaymentRequest(state).id > 0;

export const getPaidAmountFormatted = state => {
    if (isCurrentOnGoingPayementRequest(state) && getOnGoingPaymentRequest(state).paidAmout) {
        return formatAmount(getOnGoingPaymentRequest(state).paidAmout);
    }
    return null;
};

export const getDateFormatted = (state, delay = 0) => {
    if (isCurrentOnGoingPayementRequest(state) && getOnGoingPaymentRequest(state).date) {
        return toDate(timestampPlusDays(getOnGoingPaymentRequest(state).date, delay), MOMENTJS_DATE_FORMAT_STANDARD);
    }
    return null;
};

export const isFetching = state => getState(state).fetching;



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/ongoing/selector.js